import React from 'react';
import { mount, compose, route, redirect, map } from 'navi';
import { EntryListApp, EntryListAppProps } from './list';


const EntriesRoute = (props: EntryListAppProps) => {
    return route({
        title: `${props.title} | ${process.env.REACT_APP_CONTEST_TITLE}`,
        getView: () => <EntryListApp {...props} />,
    });
};

export default compose(
    map(async () => {
        return mount({
            '/': redirect('/list/6'),
            '/2': redirect('/list/6'),
            '/2/a': redirect('/list/6'),
            '/2/b': redirect('/list/6'),
            '/2/c': redirect('/list/6'),
            '/2/d': redirect('/list/6'),
            '/3': EntriesRoute({ title: '三次審査', subtitle: '進出者一覧', stage: 4 }),
            '/3/a': redirect('/list/3'),
            '/3/b': redirect('/list/3'),
            '/3/c': redirect('/list/3'),
            '/4': EntriesRoute({ title: '四次審査', subtitle: '進出者一覧', stage: 5 }),
            '/5': EntriesRoute({ title: 'セミファイナル', subtitle: '進出者一覧', stage: 6 }),
            '/6': EntriesRoute({ title: 'ファイナル', subtitle: '進出者一覧', stage: 7 }),
        });
    }),
);